(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["general-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  class KsCarousel {
    constructor(element, options = {}) {
      this.element = element;
      this.options = {
        speed: 300,
        navigation: true,
        pagination: true,
        paginationType: 'bullets',
        scrollbar: true,
        autoplay: 0,
        gapMobile: 0,
        gapDesktop: 0,
        partialSlidesMobile: true,
        breakpoints: {
          xs: 1,
          sm: 2,
          md: 2,
          lg: 2,
          xl: 3,
          xxl: 4,
        },
        ...options,
      };

      this.currentIndex = 0;
      this.slides = [];
      this.autoplayInterval = null;
      this.isTransitioning = false;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isDragging = false;

      this.init();
    }

    init() {
      this.setupElements();
      this.setupSlides();
      this.setupNavigation();
      this.setupPagination();
      this.setupScrollbar();
      this.setupAutoplay();
      this.setupTouchEvents();
      this.setupKeyboardEvents();
      this.setupResizeHandler();
      this.updateSlideStates();
      this.goToSlide(0, false);
    }

    setupElements() {
      this.wrapper = this.element.querySelector('.ks-carousel-wrapper');
      this.container = this.element.querySelector('.ks-shoppable-videos-container');
    }

    setupSlides() {
      this.slides = Array.from(this.element.querySelectorAll('.ks-carousel-slide'));
      this.totalSlides = this.slides.length;
    }

    setupNavigation() {
      this.prevButton = this.element.querySelector('.ks-carousel-button-prev');
      this.nextButton = this.element.querySelector('.ks-carousel-button-next');

      if (this.options.navigation && this.prevButton && this.nextButton) {
        this.prevButton.addEventListener('click', () => this.prev());
        this.nextButton.addEventListener('click', () => this.next());
      }
    }

    setupPagination() {
      if (!this.options.pagination) return;

      const paginationContainer = this.element.querySelector('.ks-carousel-pagination');
      if (!paginationContainer) return;

      if (this.options.paginationType === 'bullets') {
        const bulletsContainer = document.createElement('div');
        bulletsContainer.className = 'ks-carousel-bullets';

        for (let i = 0; i < this.totalSlides; i++) {
          const bullet = document.createElement('button');
          bullet.className = 'ks-carousel-bullet';
          bullet.setAttribute('aria-label', `Go to slide ${i + 1}`);
          bullet.addEventListener('click', () => this.goToSlide(i));
          bulletsContainer.appendChild(bullet);
        }

        paginationContainer.appendChild(bulletsContainer);
        this.bullets = bulletsContainer.querySelectorAll('.ks-carousel-bullet');
      } else if (this.options.paginationType === 'fraction') {
        const fraction = document.createElement('div');
        fraction.className = 'ks-carousel-fraction';
        paginationContainer.appendChild(fraction);
        this.fractionElement = fraction;
      }
    }

    setupScrollbar() {
      if (!this.options.scrollbar) return;

      const scrollbarContainer = this.element.querySelector('.ks-carousel-scrollbar');
      if (!scrollbarContainer) return;

      const drag = document.createElement('div');
      drag.className = 'ks-carousel-scrollbar-drag';
      scrollbarContainer.appendChild(drag);
      this.scrollbarDrag = drag;

      let isDragging = false;
      let startX = 0;
      let startWidth = 0;

      const handleMouseDown = (e) => {
        isDragging = true;
        startX = e.clientX;
        startWidth = drag.offsetWidth;
        drag.style.cursor = 'grabbing';
        e.preventDefault();
      };

      const handleMouseMove = (e) => {
        if (!isDragging) return;

        const deltaX = e.clientX - startX;
        const newWidth = Math.max(20, Math.min(startWidth + deltaX, scrollbarContainer.offsetWidth));
        drag.style.width = `${newWidth}px`;

        const progress = newWidth / scrollbarContainer.offsetWidth;
        const targetIndex = Math.round(progress * (this.totalSlides - 1));
        if (targetIndex !== this.currentIndex) {
          this.goToSlide(targetIndex);
        }
      };

      const handleMouseUp = () => {
        isDragging = false;
        drag.style.cursor = 'grab';
      };

      drag.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    setupAutoplay() {
      if (this.options.autoplay > 0) {
        this.startAutoplay();

        this.element.addEventListener('mouseenter', () => this.stopAutoplay());
        this.element.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    startAutoplay() {
      if (this.options.autoplay > 0 && !this.autoplayInterval) {
        this.autoplayInterval = setInterval(() => this.next(), this.options.autoplay * 1000);
      }
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    setupTouchEvents() {
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      const handleTouchStart = (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        this.stopAutoplay();
      };

      const handleTouchMove = (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
        const diff = startX - currentX;

        // Prevent page scroll if swiping horizontally within the carousel
        if (Math.abs(diff) > 10) {
          e.preventDefault();
        }
      };

      const handleTouchEnd = () => {
        if (!isDragging) return;

        const diff = startX - currentX;
        const threshold = 50;

        if (Math.abs(diff) > threshold) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }

        isDragging = false;
        this.startAutoplay();
      };

      this.wrapper.addEventListener('touchstart', handleTouchStart, { passive: false });
      this.wrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
      this.wrapper.addEventListener('touchend', handleTouchEnd);
    }

    setupKeyboardEvents() {
      const handleKeyDown = (e) => {
        if (e.key === 'ArrowLeft') {
          this.prev();
        } else if (e.key === 'ArrowRight') {
          this.next();
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      this.keyboardHandler = handleKeyDown;
    }

    setupResizeHandler() {
      const handleResize = () => {
        this.goToSlide(this.currentIndex, false);
        this.updateSlideStates();
      };

      window.addEventListener('resize', handleResize);
      this.resizeHandler = handleResize;
    }

    getSlidesPerView() {
      const width = window.innerWidth;

      if (width >= 1400) return this.options.breakpoints.xxl;
      if (width >= 1200) return this.options.breakpoints.xl;
      if (width >= 992) return this.options.breakpoints.lg;
      if (width >= 768) return this.options.breakpoints.md;
      if (width >= 576) return this.options.breakpoints.sm;
      return this.options.breakpoints.xs;
    }

    // Helper to get correct gap based on screen width
    getGap() {
      return window.innerWidth >= 750 ? this.options.gapDesktop : this.options.gapMobile;
    }

    updateSlideStates() {
      const slidesPerView = this.getSlidesPerView();
      const partialSlidesMobile = this.options.partialSlidesMobile && window.innerWidth < 576 ? 1.2 : 1;
      const effectiveSlidesPerView = slidesPerView * partialSlidesMobile;

      this.slides.forEach((slide, index) => {
        const isActive = index >= this.currentIndex && index < this.currentIndex + Math.ceil(effectiveSlidesPerView);
        slide.classList.toggle('active', isActive);
      });
    }

    goToSlide(index, animate = true) {
      if (this.isTransitioning || index === this.currentIndex) return;

      this.isTransitioning = true;
      this.element.classList.add('is-changing');

      const oldIndex = this.currentIndex;
      this.currentIndex = Math.max(0, Math.min(index, this.totalSlides - 1));

      // Calculate the maximum allowed index to prevent white space
      const slidesPerView = this.getSlidesPerView();
      const partialSlidesMobile = this.options.partialSlidesMobile && window.innerWidth < 576 ? 1.2 : 1;
      const effectiveSlidesPerView = slidesPerView * partialSlidesMobile;
      const maxIndex = Math.max(0, this.totalSlides - Math.ceil(effectiveSlidesPerView));

      // Adjust the current index if it exceeds the maximum
      if (this.currentIndex > maxIndex) {
        this.currentIndex = maxIndex;
      }

      // Calculate offset
      const slideWidth = this.getSlideWidth();
      const gap = this.getGap(); // Use responsive gap
      const offset = this.currentIndex * (slideWidth + gap);

      if (animate) {
        this.wrapper.style.transition = `transform ${this.options.speed / 1000}s cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
      } else {
        this.wrapper.style.transition = 'none';
      }

      this.wrapper.style.transform = `translateX(-${offset}px)`;

      if (animate) {
        setTimeout(() => {
          this.isTransitioning = false;
          this.element.classList.remove('is-changing');
        }, this.options.speed);
      } else {
        this.isTransitioning = false;
        this.element.classList.remove('is-changing');
      }

      this.updatePagination();
      this.updateScrollbar();
      this.updateSlideStates();

      // Trigger slide change event
      this.element.dispatchEvent(
        new CustomEvent('slideChange', {
          detail: { fromIndex: oldIndex, toIndex: this.currentIndex },
        })
      );
    }

    getSlideWidth() {
      // Get the actual width of a slide element
      if (this.slides.length > 0) {
        const slideStyle = window.getComputedStyle(this.slides[0]);
        const slideWidth = this.slides[0].offsetWidth;
        const slideMarginLeft = parseFloat(slideStyle.marginLeft) || 0;
        const slideMarginRight = parseFloat(slideStyle.marginRight) || 0;
        return slideWidth + slideMarginLeft + slideMarginRight;
      }

      // Fallback calculation
      const slidesPerView = this.getSlidesPerView();
      const containerWidth = this.container.offsetWidth;
      const gap = this.getGap(); // Use responsive gap
      const totalGap = gap * (slidesPerView - 1);
      return (containerWidth - totalGap) / slidesPerView;
    }

    next() {
      // Calculate the maximum allowed index to prevent white space
      const slidesPerView = this.getSlidesPerView();
      const partialSlidesMobile = this.options.partialSlidesMobile && window.innerWidth < 576 ? 1.2 : 1;
      const effectiveSlidesPerView = slidesPerView * partialSlidesMobile;
      const maxIndex = Math.max(0, this.totalSlides - Math.ceil(effectiveSlidesPerView));

      // If we're at the last valid position, loop back to the beginning
      const nextIndex = this.currentIndex >= maxIndex ? 0 : this.currentIndex + 1;
      this.goToSlide(nextIndex);
    }

    prev() {
      // Calculate the maximum allowed index to prevent white space
      const slidesPerView = this.getSlidesPerView();
      const partialSlidesMobile = this.options.partialSlidesMobile && window.innerWidth < 576 ? 1.2 : 1;
      const effectiveSlidesPerView = slidesPerView * partialSlidesMobile;
      const maxIndex = Math.max(0, this.totalSlides - Math.ceil(effectiveSlidesPerView));

      // If we're at the first position, loop to the last valid position
      const prevIndex = this.currentIndex <= 0 ? maxIndex : this.currentIndex - 1;
      this.goToSlide(prevIndex);
    }

    updatePagination() {
      if (this.options.paginationType === 'bullets' && this.bullets) {
        this.bullets.forEach((bullet, index) => {
          bullet.classList.toggle('active', index === this.currentIndex);
        });
      } else if (this.options.paginationType === 'fraction' && this.fractionElement) {
        // Calculate the total number of pages based on slides per view
        const slidesPerView = this.getSlidesPerView();
        const partialSlidesMobile = this.options.partialSlidesMobile && window.innerWidth < 576 ? 1.2 : 1;
        const effectiveSlidesPerView = slidesPerView * partialSlidesMobile;
        const totalPages = Math.ceil(this.totalSlides / effectiveSlidesPerView);
        const currentPage = Math.floor(this.currentIndex / effectiveSlidesPerView) + 1;

        this.fractionElement.textContent = `${currentPage}/${totalPages}`;
      }
    }

    updateScrollbar() {
      if (this.scrollbarDrag) {
        // Calculate the maximum allowed index to prevent white space
        const slidesPerView = this.getSlidesPerView();
        const partialSlidesMobile = this.options.partialSlidesMobile && window.innerWidth < 576 ? 1.2 : 1;
        const effectiveSlidesPerView = slidesPerView * partialSlidesMobile;
        const maxIndex = Math.max(0, this.totalSlides - Math.ceil(effectiveSlidesPerView));

        // Calculate progress based on current position relative to max position
        const progress = maxIndex > 0 ? this.currentIndex / maxIndex : 0;
        const scrollbarWidth = this.scrollbarDrag.parentElement.offsetWidth;
        const dragWidth = Math.max(20, scrollbarWidth / Math.ceil(this.totalSlides / effectiveSlidesPerView));
        const dragPosition = progress * (scrollbarWidth - dragWidth);

        this.scrollbarDrag.style.width = `${dragWidth}px`;
        this.scrollbarDrag.style.left = `${dragPosition}px`;
      }
    }

    destroy() {
      this.stopAutoplay();
      if (this.keyboardHandler) {
        document.removeEventListener('keydown', this.keyboardHandler);
      }
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }
  }

  class KsShoppableVideos extends HTMLElement {
    constructor() {
      super();

      // Initialize immediately when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      // Initialize custom carousel
      this.initCarousel();

      this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation(); // Prevent drag from triggering on click
          const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video');
          this.onVideoPlay(video);
        });
      });

      this.querySelectorAll('video').forEach((video) => {
        // Video pointer events are disabled in CSS, so we listen on card or wrapper
        // But if user wants to click video to play, we can use a click listener on the card wrapper
        const card = video.closest('.ks-shoppable-videos-card');
        card.addEventListener('click', (e) => {
          // Don't trigger if clicking product link or badge or buttons
          if (e.target.closest('a') || e.target.closest('button')) return;
          this.onVideoPlay(video);
        });

        // Preload videos immediately
        video.load();
      });

      // Handle autoplay videos
      const lazyVideosObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (entry.target.dataset.autoplay === 'true') {
                entry.target.play();
              }
            } else {
              // Pause when not visible to save resources
              entry.target.pause();
            }
          });
        },
        { rootMargin: '0px 0px 300px 0px' }
      );

      this.querySelectorAll('video').forEach((el) => {
        lazyVideosObserver.observe(el);
      });
    }

    initCarousel() {
      const carouselElement = this.querySelector('.ks-carousel');
      if (!carouselElement) return;

      this.carousel = new KsCarousel(carouselElement, {
        speed: Number(this.dataset.sliderSpeed),
        navigation: this.dataset.sliderNav === 'true',
        pagination: this.dataset.sliderPagination === 'true',
        paginationType: this.dataset.sliderPaginationType,
        scrollbar: this.dataset.sliderScrollbar === 'true',
        autoplay: Number(this.dataset.sliderAutoplay),
        gapMobile: Number(this.dataset.gapMobile),
        gapDesktop: Number(this.dataset.gapDesktop),
        partialSlidesMobile: this.dataset.partialSlidesMobile === 'true',
        breakpoints: {
          xs: Number(this.dataset.breakpointXs),
          sm: Number(this.dataset.breakpointSm),
          md: Number(this.dataset.breakpointMd),
          lg: Number(this.dataset.breakpointLg),
          xl: Number(this.dataset.breakpointXl),
          xxl: Number(this.dataset.breakpointXxl),
        },
      });

      carouselElement.addEventListener('slideChange', () => {
        this.onSlideChange();
      });
    }

    onSlideChange() {
      this.querySelectorAll('.ks-shoppable-videos-card').forEach((elem) => {
        elem.setAttribute('data-is-playing', 'false');
        elem.querySelector('video')?.pause();
      });
    }

    onVideoPlay(video) {
      const card = video.closest('.ks-shoppable-videos-card');

      this.querySelectorAll('.ks-shoppable-videos-card').forEach((elem) => {
        if (elem.dataset.index !== card.dataset.index) {
          elem.setAttribute('data-is-playing', 'false');
          elem.querySelector('video')?.pause();
        }
      });

      if (card.dataset.isPlaying === 'true') {
        card.setAttribute('data-is-playing', 'false');
        video.pause();
      } else {
        card.setAttribute('data-is-playing', 'true');
        video.muted = false;
        video.play();
      }
    }
  }

  customElements.define('ks-shoppable-videos', KsShoppableVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
